import React, { useState } from "react";
import Label from "./Label";
import Input from "./Input";
import { cn } from "../lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./Select";
import { firestore } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { toast } from "sonner";
import { ContactSubjects } from "../lib/constants";
import { IconLoader, IconBrandLinkedin, IconBrandInstagram } from "@tabler/icons-react";
import { motion } from "framer-motion";
type Props = {};
const initial = {
	subject: "",
	nameSurname: "",
	email: "",
	description: "",
};
const QuestionForm = ({}: Props) => {
	const [loading, setLoading] = useState(false);
	const [formValues, setFormValues] = useState(initial);

	const handleSubmit = async () => {
		if (!formValues.email || !formValues.nameSurname || !formValues.subject || !formValues.description) {
			toast("All fields required!", {
				description: "Please fill all fields to submit the form",
			});
			return;
		}
		setLoading(true);
		try {
			var deviceId = localStorage.getItem("sftdvcid");
			const contactFormCollection = collection(firestore, "contactForm"); // Firestore collection
			const documentData = {
				...formValues,
				createdAt: new Date().toISOString(),
				deviceId,
			};

			const result = await addDoc(contactFormCollection, documentData);
			if (result.id) {
				toast("We received your message!", {
					description: "We will reply to you via the email you entered as soon as possible",
				});
			}
		} catch (error: any) {
			toast("Something is not right!", {
				description: "An error occured while saving your message, please refresh the page and try again.",
			});
		}
		setFormValues(initial);
		setLoading(false);
	};
	return (
		<motion.div
			initial={{
				opacity: 0,
				scale: 0,
			}}
			whileInView={{
				opacity: 1,
				scale: 1,
				transition: {
					delay: 0.5,
					duration: 0.5,
					ease: "easeInOut",
				},
			}}
			className='max-w-md w-11/12 lg:w-full mx-auto rounded-2xl p-4 md:p-8 shadow-black/50 shadow-2xl bg-gradient-to-br from-slate-800 via-slate-950 to-slate-800'>
			<h2 className='font-medium text-xl text-neutral-200 text-center'>Fill out the form below to contact us.</h2>
			<div className='my-8 space-y-5'>
				<div className='flex flex-col md:flex-row md:space-y-0 md:space-x-2 space-y-2.5'>
					<LabelInputContainer>
						<Label htmlFor='fullname'>Name Surname</Label>
						<Input
							id='fullname'
							placeholder='Your name'
							type='text'
							onChange={(e) => {
								setFormValues({
									...formValues,
									nameSurname: e.currentTarget.value,
								});
							}}
						/>
					</LabelInputContainer>

					<LabelInputContainer>
						<Label htmlFor='email'>Email</Label>
						<Input
							id='email'
							placeholder='Your email'
							type='email'
							onChange={(e) => {
								setFormValues({ ...formValues, email: e.currentTarget.value });
							}}
						/>
					</LabelInputContainer>
				</div>
				<Select
					onValueChange={(value) => {
						setFormValues({ ...formValues, subject: value });
					}}>
					<SelectTrigger>
						<SelectValue placeholder={"Please select a subject"} />
					</SelectTrigger>
					<SelectContent>
						{ContactSubjects.map((subject) => (
							<SelectItem value={subject.title} key={subject.id}>
								{subject.title}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
				<LabelInputContainer>
					<Label htmlFor='email'>Description</Label>
					<Input
						id='Description'
						placeholder='Please enter a description'
						type='text'
						onChange={(e) => {
							setFormValues({
								...formValues,
								description: e.currentTarget.value,
							});
						}}
					/>
				</LabelInputContainer>
				<button
					onClick={handleSubmit}
					type='button'
					disabled={loading}
					className='inline-flex w-full h-12 animate-shimmer items-center justify-center rounded-lg bg-[linear-gradient(110deg,#000103,45%,#1e2631,55%,#000103)] bg-[length:200%_100%] px-6 font-medium text-white transition-colors focus:outline-none focus:ring focus:ring-slate-800'>
					{!loading ? "Submit" : <IconLoader className='animate-spin' />}
				</button>
				<div className='bg-gradient-to-r from-transparent via-neutral-500 to-transparent my-4 h-[1px] w-full' />
				<div className='text-center'>OR</div>
				<div className='bg-gradient-to-r from-transparent via-neutral-500 to-transparent my-4 h-[1px] w-full' />
				<div className='text-center'>
					Send an email to <code className='underline'>sio@softwarify.co</code>
				</div>
				<div className='bg-gradient-to-r from-transparent via-neutral-500 to-transparent my-8 h-[1px] w-full' />

				<div className='flex flex-row gap-x-3 items-center w-full justify-center'>
					<span>Follow Us on Social Media: </span>
					<a href='https://linkedin.com/company/softwarify' target='_blank' rel='linkedin'>
						<IconBrandLinkedin size={30} />
					</a>
					<a href='https://www.instagram.com/softwarify/' target='_blank' rel='instagram'>
						<IconBrandInstagram size={32} />
					</a>
				</div>
			</div>
		</motion.div>
	);
};

const LabelInputContainer = ({ children, className }: { children: React.ReactNode; className?: string }) => {
	return <div className={cn("flex flex-col space-y-2 w-full", className)}>{children}</div>;
};

export default QuestionForm;
